import { Injectable } from "@angular/core";
import { patchState, signalStore, withState } from "@ngrx/signals";
import { OstUploadStatus } from "../models/images/ost-upload-tracking.model";

export interface OstUploadTrackingState {
  ownerId: string | undefined;
  hydrated: boolean;
  statusByOst: Record<string, OstUploadStatus>;
}

const emptyOstStatus = (): OstUploadStatus => ({
  hydrated: false,
  blocked: false,
  deliveryFileNames: [],
  awaitingEventFileNames: [],
  expiredFileNames: [],
});

const initialState: OstUploadTrackingState = {
  ownerId: undefined,
  hydrated: false,
  statusByOst: {},
};

@Injectable({ providedIn: "root" })
export class OstUploadTrackingStore extends signalStore({ protectedState: false }, withState(initialState)) {
  resetForOwner(ownerId?: string): void {
    patchState(this, { ownerId, hydrated: false, statusByOst: {} });
  }

  setHydrated(ownerId: string, statusByOst: Record<string, OstUploadStatus>): void {
    patchState(this, { ownerId, hydrated: true, statusByOst });
  }

  setOstStatus(ownerId: string, ostNum: string | number, status: OstUploadStatus): void {
    if (this.ownerId?.() !== ownerId) return;
    patchState(this, {
      statusByOst: {
        ...this.statusByOst(),
        [String(ostNum)]: status,
      },
    });
  }

  getStatus(ostNum: string | number): OstUploadStatus {
    return this.statusByOst()[String(ostNum)] ?? { ...emptyOstStatus(), hydrated: this.hydrated() };
  }
}
